import { css } from 'emotion'

export const flexCenterCenterStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
`
